import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Decodetoken } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class DecodeToken extends Component {
  constructor() {
    super();
    this.state = {
      token: "",
      privkey: "",
      password: "",
      fileKeyForTokenname: "файл",
      fileKeyForTokenIsOpen: false,

      filePubKeyname: "файл",
      filePubKeyIsOpen: false,
      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputPassChange = this.handleInputPassChange.bind(this);

    this.handleFilePrivKeyChange = this.handleFilePrivKeyChange.bind(this);
    this.handleFileTokenChange = this.handleFileTokenChange.bind(this);
    this.handleDecodeTokenSubmit = this.handleDecodeTokenSubmit.bind(this);
  }

  componentDidMount() {}

  handleInputPassChange(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        password: new Buffer.from(e.target.value).toString("base64"),
      });

      ////console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }
  handleFilePrivKeyChange(e) {
    try {
      const file = document.getElementById("dataPrivKey").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({ filePubKeyname: file.name, filePubKeyIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            privkey: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ filePubKeyname: "файл", filePubKeyIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileTokenChange() {
    try {
      const file = document.getElementById("dataToken").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({
          fileKeyForTokenname: file.name,
          fileKeyForTokenIsOpen: true,
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            token: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          fileKeyForTokenname: "файл",
          fileKeyForTokenIsOpen: false,
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleDecodeTokenSubmit(e) {
    e.preventDefault();
    try {
      Decodetoken(
        this.state.token,
        this.state.privkey,
        this.state.password
      ).then((res) => {
        try {
          //console.log(res);
          if (res.status === 200) {
            FileDownload(res.data.privKey, "privkey.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";
          }
        } catch (error) {
          document.getElementById("view").style.borderColor = "red";
          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h4 className="major">Cнятие защиты с ключа</h4>
        <Form onSubmit={this.handleDecodeTokenSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Токен</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataToken"
                  onChange={this.handleFileTokenChange}
                  isValid={this.state.fileKeyForTokenIsOpen}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.fileKeyForTokenname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Личный ключ</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataPrivKey"
                  onChange={this.handleFilePrivKeyChange}
                  isValid={this.state.filePubKeyIsOpen}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filePubKeyname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                type="password"
                placeholder="Пароль"
                onChange={this.handleInputPassChange}
                style={{ height: "2rem" }}
                required
              />
            </Form.Group>
            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Снять защиту
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(DecodeToken));
